import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuItem, NbMenuModule, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbAuthJWTToken, NbAuthService, NbTokenService, NbAuthSimpleToken, NbAuthToken } from '@nebular/auth';
import { Router } from '@angular/router';
@Component({
  selector: 'ngx-header',
  //changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user:any;
  position: string = 'normal';
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: 'Thông tin cá nhân' },
    { title: 'Danh sách bệnh án', },
    { title: 'Danh sách yêu cầu' },
    { title: 'Thay đổi mật khẩu' },
    { title: 'Đăng xuất', link: '/auth/logout' }];
  NotifiMenu = [{ title1: 'Phiếu yêu cầu', title2: 'Thẩm định bệnh án', title3: 'đã dược thẩm định thành công', maphieu: 'D27288F', thoigian: '10 phút' }, { title1: 'Phiếu yêu cầu', title2: 'Thẩm định bệnh án', title3: 'đã dược thẩm định thành công', maphieu: 'D27288F', thoigian: '10 phút' }, { title1: 'Phiếu yêu cầu', title2: 'Thẩm định bệnh án', title3: 'đã dược thẩm định thành công', maphieu: 'D27288F', thoigian: '10 phút' },];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    //private userService: UserData,
    private router: Router,
    private layoutService: LayoutService,
    private authService: NbAuthService,
    private tokenService: NbTokenService,
    private breakpointService: NbMediaBreakpointsService) {
    this.tokenService.get().subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {
        this.user = token.getPayload();
      } else {
        // this.router.navigate([`auth/login`, { replace: true }]);
      }
    })

  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    //this.userService.getUsers()
    //  .pipe(takeUntil(this.destroy$))
    //  .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return true;
  }
  toggle = true;
  status = 'Enable'; 

  enableDisableRule(job) {
    this.toggle = !this.toggle;
    this.status = this.toggle ? 'Enable' : 'Disable';
    
  }

  goToHome() {

  }
}
